module.exports = __webpack_public_path__ + "static/media/mn15.4f3384b4.jpeg";